import { render, staticRenderFns } from "./BirdIcon.vue?vue&type=template&id=1f1f8e77&scoped=true"
import script from "./BirdIcon.vue?vue&type=script&lang=js"
export * from "./BirdIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f8e77",
  null
  
)

export default component.exports